import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import { SortBy } from 'src/app/Enums/sortEnums';
import { UsersFilterService } from 'src/app/shared/classes/filter';
import { UsersService } from 'src/app/shared/services/users.service';

@Component({
  selector: 'app-users-filter',
  templateUrl: './users-filter.component.html',
  styleUrls: ['./users-filter.component.css']
})
export class UsersFilterComponent implements OnInit {

  @Input() column;

  @Output() gridFiltersApplied = new EventEmitter();

  @Input() roleArray;
  @Input() cityArray;
  @Input() officeArray;
  @Input() statusArray;


  filteredData : any;

  @Input() tableSettings;
  private unsubscribe$ =new Subject<void>();


  selectAllCityType: {isChecked: boolean} = {isChecked : true};
  selectAllRoleType: {isChecked: boolean} = {isChecked : true};
  selectAllOfficeType: {isChecked: boolean} = {isChecked : true};
  selectAllStatusType: {isChecked: boolean} = {isChecked : true};


  isUnSelectAll: boolean = false;
  
  constructor(private usersService : UsersService) { }

  ngOnInit() {

    this.usersService.resetFilters
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {   
         
      this.resetFilters();
      
      this.usersService.resetHeaders.next();          
    });

    this.checkSelectAllFilter();
    this.checkFilterValue();
  }


  selectAllCityTypeFilter(check) {
    if (check) {
      this.cityArray.forEach(item => {
        item.isCheck = true;
      })
    }
    else {
      this.cityArray.forEach(item => {
        item.isCheck = false;
      })
    }
  }

  selectAllRoleTypeFilter(check) {
    if (check) {
      this.roleArray.forEach(item => {
        item.isCheck = true;
      })
    }
    else {
      this.roleArray.forEach(item => {
        item.isCheck = false;
      })
    }
  }

  selectAllOfficeTypeFilter(check) {
    if (check) {
      this.officeArray.forEach(item => {
        item.isCheck = true;
      })
    }
    else {
      this.officeArray.forEach(item => {
        item.isCheck = false;
      })
    }
  }

  selectAllStatusTypeFilter(check) {
    if (check) {
      this.statusArray.forEach(item => {
        item.isCheck = true;
      })
    }
    else {
      this.statusArray.forEach(item => {
        item.isCheck = false;
      })
    }
  }


  checkFilterValue(){

    if(UsersFilterService.cityList.length == 0 && UsersFilterService.cityList.indexOf('None') < 0){
      
      this.selectAllCityTypeFilter(true);
    }
    if(UsersFilterService.roleList.length == 0 && UsersFilterService.roleList.indexOf('None') < 0){
      
      this.selectAllRoleTypeFilter(true);
    }
    if(UsersFilterService.officesList.length == 0 && UsersFilterService.officesList.indexOf('None') < 0){
      
      this.selectAllOfficeTypeFilter(true);
    }
    if(UsersFilterService.statusList.length == 0 && UsersFilterService.statusList.indexOf('None') < 0){
      
      this.selectAllStatusTypeFilter(true);
    }
  }

  


  checkSelectAllFilter(){
    if(UsersFilterService.cityList.length > 0 && UsersFilterService.cityList.indexOf('None') >-1){
      this.selectAllCityType.isChecked = false;
    }
    if(UsersFilterService.roleList.length > 0 && UsersFilterService.roleList.indexOf('None') >-1){
      this.selectAllRoleType.isChecked = false;
    }
    if(UsersFilterService.officesList.length > 0 && UsersFilterService.officesList.indexOf('None') >-1){
      this.selectAllOfficeType.isChecked = false;
    }
    if(UsersFilterService.statusList.length > 0 && UsersFilterService.statusList.indexOf('None') >-1){
      this.selectAllStatusType.isChecked = false;
    }
     
  }

      // Selection/unselection of filter options
  togglefilter(arrayType,selectAllValue,checked){
    
        var allTypeCount = arrayType.length;
        var checkedTypeCount = 0;
        arrayType.forEach(item => {
          if (item.isCheck) {              
            checkedTypeCount = checkedTypeCount + 1;
          }
        })

          // _.each(arrayType,function(item){
          //   if (item.isCheck) {
              
          //     checkedTypeCount = checkedTypeCount + 1;
          //   }
          // })
                  
        if(!checked){
          
            selectAllValue.isChecked = false;
        }
        else{
          if(allTypeCount == checkedTypeCount){
            selectAllValue.isChecked = true;
          }
          else{
            selectAllValue.isChecked = false;
          }
        }
  }

  checkSelectedCityType(arrayList,column){
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {
        selectedType.push(item.name);
      }
    })


      if(selectedType.length == arrayList.length){
        UsersFilterService.cityList = [];
      }
      else{
        return UsersFilterService.cityList = selectedType;
      } 
  }

  checkSelectedRoleType(arrayList,column){
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {
        selectedType.push(item.name);
      }
    })

      if(selectedType.length == arrayList.length){
        UsersFilterService.roleList = [];
      }
      else{
        return UsersFilterService.roleList = selectedType;
      }
  }

  checkSelectedOfficeType(arrayList,column){
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {
        selectedType.push(item.name);
      }
    })

      if(selectedType.length == arrayList.length){
        UsersFilterService.officesList = [];
      }
      else{
        return UsersFilterService.officesList = selectedType;
      }
  }
  checkSelectedStatusType(arrayList,column){
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {            
        selectedType.push(item.name);            
}
    })
      if(selectedType.length == arrayList.length){
        UsersFilterService.statusList = [];
      }
      else{
        return UsersFilterService.statusList = selectedType;
      }
  }
  

  onFilterApply(column){

    this.isUnSelectAll = false;

    if(column.isResNameSortA) {
      column.sortOrder = 'Asc';
      
    }else if (column.isResNameSortD) {
      column.sortOrder = 'Desc';

    }else if (column.isResNameSortN) {
      column.sortOrder = '';
    
    }

    column.displaysort = false;
   
    if(column.sortBy == SortBy.City){          
      this.checkSelectedCityType(this.cityArray,column);
    }
    if(column.sortBy == SortBy.Role){          
      this.checkSelectedRoleType(this.roleArray,column);
    }
    if(column.sortBy == SortBy.Office){          
      this.checkSelectedOfficeType(this.officeArray,column);
    }
    if(column.sortBy == SortBy.Status){          
      this.checkSelectedStatusType(this.statusArray,column);
    }
          
    if(!this.isUnSelectAll){
    column.isFilterApplied = true;
  
    this.gridFiltersApplied.emit(true);
    }

  }

  resetEvents(){
    this.tableSettings.columns.forEach(item => {
      item.displaysort = false;
    })
}

  resetFilters()
  {        
    this.selectAllCityTypeFilter(true);
    this.selectAllCityType.isChecked = true;
    this.selectAllRoleTypeFilter(true);
    this.selectAllRoleType.isChecked = true;
    this.selectAllOfficeTypeFilter(true);
    this.selectAllOfficeType.isChecked = true;
    this.selectAllStatusTypeFilter(true);
    this.selectAllStatusType.isChecked = true;

  }
  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }





}
